import { defineStore } from 'pinia'
import { store } from '../index'
import enUS from 'ant-design-vue/es/locale/en_US'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import frFR from 'ant-design-vue/es/locale/fr_FR'
import { useStorage } from '@/hooks/web/useStorage'

const { getStorage, setStorage } = useStorage('localStorage')

const elLocaleMap = {
  'zh-cn': zhCN,
  en: enUS,
  fr: frFR
}

export const useLocaleStore = defineStore('locales', {
  state: () => {
    return {
      currentLocale: {
        lang: getStorage('lang') || 'en',
        elLocale: elLocaleMap[getStorage('lang') || 'en']
      },
      // 多语言
      localeMap: [
        {
          lang: 'en',
          name: 'English'
        },
        {
          lang: 'fr',
          name: 'Français'
        },
        {
          lang: 'zh-cn',
          name: '简体中文'
        }
      ]
    }
  },
  getters: {
    getCurrentLocale(): { lang: LocaleType; elLocale: object } {
      return this.currentLocale
    },
    getLocaleMap(): { lang: string; name: string }[] {
      return this.localeMap
    }
  },
  actions: {
    setCurrentLocale(localeMap: { lang: string }) {
      this.currentLocale.lang = localeMap?.lang
      this.currentLocale.elLocale = elLocaleMap[localeMap?.lang]
      setStorage('lang', localeMap?.lang)
    }
  }
})

export const useLocaleStoreWithOut = () => {
  return useLocaleStore(store)
}
